/**
 * DevExtreme (esm/__internal/core/license/trial_panel.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    isClient,
    registerCustomComponents,
    renderTrialPanel
} from "./trial_panel.client";
export function showTrialPanel(buyNowUrl, licensingDocUrl, version, customStyles) {
    if (isClient()) {
        renderTrialPanel(buyNowUrl, licensingDocUrl, version, customStyles)
    }
}
export function registerTrialPanelComponents(customStyles) {
    if (isClient()) {
        registerCustomComponents(customStyles)
    }
}
